export default "__VITE_ASSET__DxHDv5Sp__"